import { DecimalPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { IonicModule } from "ionic-angular";
import { TruncateModule } from "ng2-truncate";
import { ApprovalInputComponent } from "./approval-input/approval-input";
import { CheckboxCommentInputComponent } from "./checkbox-comment-input/checkbox-comment-input";
import { CheckboxInputComponent } from "./checkbox-input/checkbox-input";
import { ConversionInputComponent } from "./conversion-input/conversion-input";
import { DateParagraphComponent } from "./date-paragraph/date-paragraph";
import { DatetimeInputComponent } from "./datetime-input/datetime-input";
import { DocumentInputComponent } from "./document-input/document-input";
import { DynamicInputComponent } from "./dynamic-input/dynamic-input";
import { ExpandableComponent } from "./expandable/expandable";
import { ExpandoParagraphComponent } from "./expando-paragraph/expando-paragraph";
import { FixedLabelSearchSelectComponent } from "./fixed-label-search-select/fixed-label-search-select.component";
import { FixedLabelTextInputComponent } from "./fixed-label-text-input/fixed-label-text-input.component";
import { FixedLabelTextAreaInputComponent } from "./fixed-label-textarea-input/fixed-label-textarea-input.component";
import { FrequencyInputComponent } from "./frequency-input/frequency-input";
import { HiddenInputComponent } from "./hidden-input/hidden-input";
import { HorizontalRadioInputComponent } from "./horizontal-radio-input/horizontal-radio-input";
import { InputLegend } from "./input-legend/input-legend";
import { InputText } from "./input-text/input-text";
import { LengthInputComponent } from "./length-input/length-input";
import { NewDateTimePicker } from "./new-date-time-picker/new-date-time-picker";
import { NumberInputComponent } from "./number-input/number-input";
import { OxygenFrequencyInputComponent } from "./oxygen-input/oxygen-frequency-input";
import { RadioInputComponent } from "./radio-input/radio-input";
import { RangeInputComponent } from "./range-input/range-input";
import { SearchSelectComponent } from "./search-select/search-select";
import { SelectFilterComponent } from "./select-filter/select-filter";
import { SelectInputComponent } from "./select-input/select-input";
import { SelectSearchInputComponent } from "./select-search-input/select-search-input";
import { TextInputComponent } from "./text-input/text-input";
import { TextareaInputComponent } from "./textarea-input/textarea-input";
import { ToggleInputComponent } from "./toggle-input/toggle-input";
import { TranslatedHeaderComponent } from "./translated-header/translated-header";
import { VoiceTextareaInputComponent } from "./voice-textarea-input/voice-textarea-input";

@NgModule({
  declarations: [
    ApprovalInputComponent,
    CheckboxInputComponent,
    CheckboxCommentInputComponent,
    ConversionInputComponent,
    DatetimeInputComponent,
    DateParagraphComponent,
    DocumentInputComponent,
    DynamicInputComponent,
    ExpandableComponent,
    ExpandoParagraphComponent,
    FrequencyInputComponent,
    HorizontalRadioInputComponent,
    LengthInputComponent,
    NumberInputComponent,
    OxygenFrequencyInputComponent,
    RadioInputComponent,
    RangeInputComponent,
    SearchSelectComponent,
    SelectFilterComponent,
    SelectInputComponent,
    TextInputComponent,
    TextareaInputComponent,
    ToggleInputComponent,
    TranslatedHeaderComponent,
    SelectSearchInputComponent,
    HiddenInputComponent,
    InputText,
    NewDateTimePicker,
    InputLegend,
    VoiceTextareaInputComponent,
    FixedLabelTextInputComponent,
    FixedLabelTextAreaInputComponent,
    FixedLabelSearchSelectComponent,
  ],
  imports: [
    IonicModule,
    TranslateModule.forChild(),
    TruncateModule,
    CommonComponentsModule,
    NgbModule.forRoot(),
    NgSelectModule,
  ],
  exports: [
    ApprovalInputComponent,
    CheckboxInputComponent,
    CheckboxCommentInputComponent,
    ConversionInputComponent,
    DatetimeInputComponent,
    DateParagraphComponent,
    DocumentInputComponent,
    DynamicInputComponent,
    ExpandableComponent,
    ExpandoParagraphComponent,
    FrequencyInputComponent,
    HorizontalRadioInputComponent,
    LengthInputComponent,
    NumberInputComponent,
    OxygenFrequencyInputComponent,
    RadioInputComponent,
    RangeInputComponent,
    SearchSelectComponent,
    SelectFilterComponent,
    SelectInputComponent,
    TextareaInputComponent,
    TextInputComponent,
    ToggleInputComponent,
    TranslatedHeaderComponent,
    SelectSearchInputComponent,
    HiddenInputComponent,
    InputText,
    NewDateTimePicker,
    InputLegend,
    VoiceTextareaInputComponent,
    FixedLabelTextInputComponent,
    FixedLabelTextAreaInputComponent,
    FixedLabelSearchSelectComponent,
  ],
  providers: [DecimalPipe, TranslatePipe],
})
export class ConfigurableInputsModule {}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/configurable-inputs.module.ts